// Bounds a promise that something the user is waiting on depends on. An unbounded await inside a
// guard, an interceptor or a boot sequence does not surface as an error — it stops the navigation
// from ever settling, which the app renders as an endless loader (WI 8623).
export function promiseWithTimeout<T>(promise: Promise<T>, timeoutMs: number, onTimeout: () => T): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout>;
  const timeout = new Promise<T>(resolve => {
    timeoutId = setTimeout(() => resolve(onTimeout()), timeoutMs);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timeoutId));
}
